module.exports = __webpack_public_path__ + "Mainview@2x.png?85101993a52e07c735d372d38c50714c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mainview@2x.png
// module id = 40
// module chunks = 0